import React from 'react';
import PropTypes from 'prop-types';
import { Banner } from 'components/banner';

const BannerCard = ({ model }) => (
    <div className="row row--content-center">
        <div className="row__item row__item--span-8">
            <Banner model={model} />
        </div>
    </div>
);

BannerCard.propTypes = {
    model: PropTypes.object.isRequired
};

export default BannerCard;
